/**
 * Класс для управления мобильным меню
 * Реализует функциональность открытия/закрытия меню с блокировкой прокрутки body
 */

// Константы селекторов
const SELECTORS = {
  OPEN_BUTTON: ".mobile-menu-open-button",
  CLOSE_BUTTON: ".mobile-menu-close-button",
  MENU: ".mobile-menu",
  OVERLAY: ".bg-overlay",
  OVERLAY_CLOSE_BUTTON: ".bg-overlay__close",
  ACTIVE_MENU_CLASS: "mobile-menu--active",
  ACTIVE_OVERLAY_CLASS: "bg-overlay--active",
  FOCUSABLE: 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])',
};

class MobileMenu {
  /**
   * Конструктор класса MobileMenu
   */
  constructor() {
    this.openButton = document.querySelector(SELECTORS.OPEN_BUTTON);
    this.closeButton = document.querySelector(SELECTORS.CLOSE_BUTTON);
    this.menu = document.querySelector(SELECTORS.MENU);
    this.overlay = document.querySelector(SELECTORS.OVERLAY);
    this.overlayCloseButton = document.querySelector(
      SELECTORS.OVERLAY_CLOSE_BUTTON,
    );

    this.init();
  }

  /**
   * Инициализация обработчиков событий
   */
  init() {
    // Проверка наличия всех необходимых элементов
    if (
      !this.openButton ||
      !this.closeButton ||
      !this.menu ||
      !this.overlay
    ) {
      console.warn("MobileMenu: Не все необходимые элементы найдены в DOM");
      return;
    }

    // Обработчик клика по кнопке открытия
    this.openButton.addEventListener("click", this.openMenu.bind(this));

    // Обработчик клика по кнопке закрытия
    this.closeButton.addEventListener("click", this.closeMenu.bind(this));

    // Обработчик клика по overlay для закрытия меню
    this.overlay.addEventListener("click", this.closeMenu.bind(this));

    // Обработчик клика по кнопке закрытия внутри overlay (если есть)
    if (this.overlayCloseButton) {
      this.overlayCloseButton.addEventListener(
        "click",
        this.closeMenu.bind(this),
      );
    }

    // Escape закрывает меню, Tab не выпускает фокус за его пределы
    document.addEventListener("keydown", (event) => {
      if (!this.isOpen()) {
        return;
      }

      if (event.key === "Escape") {
        this.closeMenu();
      } else if (event.key === "Tab") {
        this.trapFocus(event);
      }
    });
  }

  isOpen() {
    return this.menu.classList.contains(SELECTORS.ACTIVE_MENU_CLASS);
  }

  /**
   * Зацикливает Tab / Shift+Tab внутри открытого меню
   * @param {KeyboardEvent} event
   */
  trapFocus(event) {
    const focusable = this.menu.querySelectorAll(SELECTORS.FOCUSABLE);
    if (focusable.length === 0) {
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || !this.menu.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !this.menu.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  /**
   * Открытие мобильного меню
   */
  openMenu() {
    // Добавляем классы активности
    this.menu.classList.add(SELECTORS.ACTIVE_MENU_CLASS);
    this.overlay.classList.add(SELECTORS.ACTIVE_OVERLAY_CLASS);

    // Блокируем прокрутку body
    this.toggleBodyScroll(true);

    this.openButton.setAttribute("aria-expanded", "true");
    this.closeButton.focus();
  }

  /**
   * Закрытие мобильного меню
   */
  closeMenu() {
    // Убираем классы активности
    this.menu.classList.remove(SELECTORS.ACTIVE_MENU_CLASS);
    this.overlay.classList.remove(SELECTORS.ACTIVE_OVERLAY_CLASS);

    // Разблокируем прокрутку body
    this.toggleBodyScroll(false);

    this.openButton.setAttribute("aria-expanded", "false");
    // Возвращаем фокус туда, откуда меню было открыто
    this.openButton.focus();
  }

  /**
   * Блокировка/разблокировка прокрутки body
   * @param {boolean} lock - true для блокировки, false для разблокировки
   */
  toggleBodyScroll(lock) {
    if (lock) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }
}

/**
 * Инициализация мобильного меню после загрузки DOM
 */
document.addEventListener("DOMContentLoaded", function () {
  new MobileMenu();
});

export default MobileMenu;
